import { useQuery } from "@tanstack/react-query"
import { getAllProjectSections } from "../../../api/projects/getAllProjectSections"

export const useGetAllProjectSections = (projectId: number) => {

  return useQuery({
    queryKey: ['allProjectSections', projectId],
    queryFn: () => getAllProjectSections(projectId),
    staleTime: 1000 * 60 * 5, // Reducir a 5 minutos
    gcTime: 1000 * 60 * 10, // 10 minutos en cache
    retry: (failureCount, error: unknown) => {
      // No reintentar en caso de timeout
      if ((error as Error & { code?: string })?.code === 'ECONNABORTED' || (error as Error)?.message?.includes('timeout')) {
        return false;
      }
      return failureCount < 2;
    },
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    refetchOnWindowFocus: false,
    refetchOnMount: true
  })
}
